import {
  CAMPAIGN_LOADING,
  GET_CAMPAIGN,
  GET_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_FAIL,
  ADD_CAMPAIGN_SUCCESS,
  ADD_CAMPAIGN_FAIL,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_FAIL,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_FAIL,
  CAMPAIGN_RESET
} from "./actionType";

const INIT_STATE = {
  campaigns: [],
  error: {},
};

const Campaign = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CAMPAIGN:
          return {
            ...state,
            campaigns: action.payload.data,
            isCampaignCreated: false,
            isCampaignSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CAMPAIGN_FAIL:
      switch (action.payload.actionType) {
        case GET_CAMPAIGN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCampaignCreated: false,
            isCampaignSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CAMPAIGN: {
      return {
        ...state,
        isCampaignCreated: false,
        loading: true,
      };
    }

    case CAMPAIGN_LOADING: {
      return {
        ...state,
        isCampaignCreated: false,
        loading: true,
      };
    }

    case ADD_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isCampaignCreated: true,
        loading: false,
        campaigns: [action.payload.data, ...state.campaigns],
      };

    case ADD_CAMPAIGN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        isCampaignCreated: true,
        campaigns: state.campaigns.filter(
          campaign => campaign.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CAMPAIGN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        isCampaignCreated: true,
        campaigns: state.campaigns.map(campaign =>
          campaign.id.toString() === action.payload.data.id.toString() ? { ...campaign, ...action.payload.data } : campaign
        ),
      };

    case UPDATE_CAMPAIGN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CAMPAIGN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Campaign;